<template>
  <div class="tab-page">
    <div class="type-wrapper">
      <span
        class="pr-20"
        :class="{ active: type === 'manufacturers' }"
        @click="selectType('manufacturers')"
        v-if="p('Products.Manufacturers.View')"
      >
        {{ $t('text.manufacturers') }}
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'products' }"
        @click="selectType('products')"
        v-if="
          p('Products.Product Description.View') ||
            p('Products.Product Characteristics.View')
        "
      >
        {{ $t('text.products').toLowerCase() }}
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'characterisation' }"
        @click="selectType('characterisation')"
        v-if="p('Products.Run.View') || p('Products.Analyse Runs.View')"
      >
        {{ $t('text.characterisation') }}
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'modelGenerator' }"
        @click="selectType('modelGenerator')"
        v-if="p('Products.Model Generator.View')"
      >
        Model Generator
      </span>
    </div>
    <Manufacturers v-if="type === 'manufacturers'" />
    <Products v-if="type === 'products'" />
    <Characterisation v-if="type === 'characterisation'" />
    <ModelGenerator v-if="type === 'modelGenerator'" />
  </div>
</template>

<script>
import Manufacturers from '@/components/products/Manufacturers'
import Products from '@/components/products/Products'
import Characterisation from '@/components/products/Characterisation'
import ModelGenerator from '@/views/ModelGenerator'
export default {
  data() {
    return {
      type: 'manufacturers'
    }
  },
  components: {
    Manufacturers,
    Products,
    Characterisation,
    ModelGenerator
  },
  mounted() {
    this.type = this.$permission('Products.Manufacturers.View')
      ? 'manufacturers'
      : this.$permission('Products.Product Description.View') ||
        this.$permission('Products.Product Characteristics.View')
      ? 'products'
      : 'characterisation'
  },
  methods: {
    selectType(type) {
      this.type = type
    }
  }
}
</script>
